module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2021_fr-e665075063941c9c35dc0be942067375.jpg";